/** Auto-hide delay (ms) for the transient Best-in-Dental toasts. */
export const BID_TOAST_AUTO_HIDE_MS = 4000;
